import React from 'react';
import { WorkspaceHero } from '../components/WorkspaceHero';
import { NovaSection } from '../components/nova/NovaSection';
import { AudienceSwitch } from '../components/AudienceSwitch';
import { LivesInSlack } from '../components/LivesInSlack';
import { ComputerUse } from '../components/ComputerUse';
import { CapabilityGrid } from '../components/CapabilityGrid';
import { NarrativeSection } from '../components/NarrativeSection';
import { WallOfLove } from '../components/WallOfLove';
import { GettingStartedSteps } from '../components/GettingStartedSteps';
import { PricingSection } from '../components/PricingSection';
import { ClosingCTA } from '../components/ClosingCTA';
// Exploration variant of the home page. Identical to Home, but the hero is
// reimagined as an animated Slack/Teams workspace where colleagues @mention
// Giga and Giga replies with finished work — a place to explore the
// "chat box as a real workspace" direction.
export function WorkspaceHome() {
  return <>
      <WorkspaceHero data-id="element-6048" />
      <NovaSection data-id="element-6049" />
      <AudienceSwitch data-id="element-6050" />
      <LivesInSlack data-id="element-6051" />
      <ComputerUse data-id="element-6052" />
      <CapabilityGrid data-id="element-6053" />
      <NarrativeSection data-id="element-6054" />
      <WallOfLove data-id="element-6055" />
      <GettingStartedSteps data-id="element-6056" />
      <PricingSection data-id="element-6057" />
      <ClosingCTA data-id="element-6058" />
    </>;
}